'use client';

/* eslint-disable @next/next/no-img-element */
import React, { ReactNode } from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { NewMenuItem } from 'ui/src/data/MenuItem';
import Flyout from 'ui/src/components/Flyout';

import ButtonLink from 'ui/src/components/ButtonLink';
import { AllIcons } from 'ui/src/components/Icon';
import MobileHeader from '../mobileHeader';
import HeaderContainer, { type HeaderProps } from './HeaderContainer';

export type BairesDevHeaderProps = HeaderProps & {
  menuItems: NewMenuItem[];
  logoPath: string;
  headerLogoUrl?: string;
  headerLinkChildren?: ReactNode;
  ctaLabel?: string;
  ctaLink?: string;
  ctaIconName?: AllIcons;
};

function BairesDevHeader({
  menuItems,
  logoPath,
  enableHeaderBehavior,
  animatedHeader,
  headerLogoUrl = process.env.NEXT_PUBLIC_HOSTNAME,
  headerLinkChildren = null,
  ctaLabel = 'Schedule a Call',
  ctaLink = 'https://www.bairesdev.com/start/basic-details/',
  ctaIconName = undefined,
}: BairesDevHeaderProps) {
  return (
    <HeaderContainer enableHeaderBehavior={enableHeaderBehavior} animatedHeader={animatedHeader}>
      <div className="flex">
        <a href={`${headerLogoUrl ?? 'https://www.bairesdev.com'}/`} className={twMerge('block h-[22px]')}>
          <div className="lgS:w-auto h-7 w-8 overflow-hidden">
            <img
              src={logoPath}
              alt="BairesDev"
              width={188}
              height={28}
              className="h-7 w-48 cursor-pointer object-cover object-left"
            />
          </div>
        </a>
        {headerLinkChildren}
      </div>

      <div className={twMerge('mdL:h-full mdL:flex hidden h-auto')}>
        <nav aria-label="BairesDev main navigation" className="flex h-full items-center">
          <Flyout menuItems={menuItems} hasLeftText={!!headerLinkChildren} />
          <ButtonLink
            variant="Primary"
            variantColor="Black"
            size="Medium"
            classes="ml-8 mdL:ml-2"
            href={ctaLink}
            iconName={ctaIconName}
          >
            {ctaLabel}
          </ButtonLink>
        </nav>
      </div>

      <MobileHeader menuItems={menuItems} />
    </HeaderContainer>
  );
}

export default BairesDevHeader;
